import React from "react";
import { DocumentRenderer } from "components";
import withData from "./withData";
import HeaderData from "./HeaderData";
import PackingSlipLineItems from "./PackingSlipLineItems";
import { convertUTCToLocal, getStyle, LAYOUT_COMPONENTS_MAP } from "services/util";


export const PackingSlipDocument = ({
  item,
  contact,
  settings,
  organisation,
  taxRates,
  t,
  qrCode,
  ...props
}) => {

  // const defaultLayoutSettings = settings?.invoice_layout_settings?.find(x => x.is_default === true)
  const defaultLayoutSettings = null

  let Header = LAYOUT_COMPONENTS_MAP[defaultLayoutSettings?.layout] || LAYOUT_COMPONENTS_MAP.default

  let baseStyle = { fontSize: (defaultLayoutSettings?.font_size || settings.font_size_base || 16) + 'px' }

  if (defaultLayoutSettings) {
    if (defaultLayoutSettings?.font_family) {
      baseStyle = { ...baseStyle, fontFamily: defaultLayoutSettings?.font_family }
    }

    if (defaultLayoutSettings?.font_color) {
      baseStyle = { ...baseStyle, color: defaultLayoutSettings?.font_color }
    }

  }

  const invoiceLogoStyle = getStyle(defaultLayoutSettings?.invoice_logo_style)
  const invoiceTitleStyle = getStyle(defaultLayoutSettings?.invoice_title_style)
  const invoiceLabelStyle = getStyle(defaultLayoutSettings?.invoice_label_style)
  const invoiceContentStyle = getStyle(defaultLayoutSettings?.invoice_content_style)
  const lineItemHeaderStyle = getStyle(defaultLayoutSettings?.line_item_header_style)
  const lineItemStyle = getStyle(defaultLayoutSettings?.line_item_style)

  return (

    <DocumentRenderer {...props}>
      
      <div className="container-fluid my-3" style={baseStyle} >

        <Header
          item={item}
          company={organisation}
          client={contact}
          t={t}
          settings={settings}
          doc_name={'Packing Slip'}
          hideAttention={true}
          logo={settings.logo}
          defaultLayoutSettings={defaultLayoutSettings}
          invoiceLogoStyle={invoiceLogoStyle}
          invoiceTitleStyle={invoiceTitleStyle}
          invoiceLabelStyle={invoiceLabelStyle}
          invoiceContentStyle={invoiceContentStyle}
        >
          <HeaderData className="mb-1" label="Date" value={item.DateString} />
          <HeaderData className="mb-1" label="Time" value={convertUTCToLocal(item.UpdatedDateUTC)} />
          <HeaderData className="mb-1" label="Invoice Number" value={item.InvoiceNumber} />
          <HeaderData className="mb-1" label="Reference" value={item.Reference} />
          <HeaderData className="mb-1" label="Supply Date" value={item.ExpectedPaymentDateString?.substr(0, 10)} />
        </Header>

        <PackingSlipLineItems 
          invoice={item} 
          lineItemHeaderStyle={lineItemHeaderStyle}
          lineItemStyle={lineItemStyle}
        />

      </div>
    </DocumentRenderer>
  )
};

export default withData(PackingSlipDocument);
